import React from 'react';

export default function BurningManBikeIdeas() {
  return (
    <main style={{ padding: '1rem', lineHeight: 1.6, fontFamily: 'sans-serif', maxWidth: 800, margin: '0 auto' }}>
      <p><a href="/">&larr; Back to home</a></p>
      <h1>Burning Man Bike Ideas</h1>
      <p>
        Getting around Black Rock City is a lot easier with a trusty bike. Here
        are a few ideas to keep your ride functional, unique, and safe on the
        playa.
      </p>
      <h2>1. Light It Up</h2>
      <p>
        Add LED strips or EL wire so your bike stands out at night. Bright
        lighting not only looks great but also keeps you visible on the dark
        playa.
      </p>
      <h2>2. Dust-Proof Your Ride</h2>
      <p>
        Playa dust gets everywhere. Use a dust-resistant chain lube and cover
        your seat when not riding to keep things moving smoothly.
      </p>
      <h2>3. Secure Your Bike</h2>
      <p>
        Bike theft happens, even at Burning Man. Bring a sturdy lock and tag
        your bike with something distinctive so you can spot it in a crowd.
      </p>
      <p>
        With a little preparation, your bike can be a reliable companion for the
        entire week. Personalize it, protect it, and enjoy the ride!
      </p>
    </main>
  );
}

